import { render } from "./StarsIcon.vue?vue&type=template&id=70d71af4&ts=true"
import script from "./StarsIcon.vue?vue&type=script&lang=ts"
export * from "./StarsIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__